import $ from "jquery";
import Storage from "@bd-utils/storage";
import {
    computePosition,
    offset,
    shift,
    arrow,
    autoPlacement,
} from "@floating-ui/dom";

const inverses = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right",
};
export default class Tutorial {
    constructor() {
        this.elms = {
            tutorial: ".js-tutorial",
            btnCloseTutorial: ".js-tutorial-close",
            btnNextTutorial: ".js-next-tutorial",
            btnBackTutorial: ".js-back-tutorial",
            briefing: ".briefing",
        };

        if (!this.initialized) this.registerEvents();

        this.roomId = false;

        return this;
    }

    _setHasSeen(roomId) {
        let states = Storage.get("states", {});
        if (!states?.tutorial) states.tutorial = [];
        states.tutorial.push(roomId);
        return Storage.set("states", states);
    }

    _getHasSeen(roomId) {
        let states = Storage.get("states", {});
        return states?.tutorial && states.tutorial.includes(roomId);
    }

    init(roomId) {
        this.roomId = roomId;

        const $tutorial = $(this.elms.tutorial);

        if (!$tutorial.length) return;

        if (this._getHasSeen(roomId)) return;

        if ($(this.elms.briefing).hasClass("is-open")) return;

        this.setTutorialPosition();

        $tutorial.addClass("is-open");
        $tutorial.find(".tutorial__body").first().removeClass("is-hide");
    }

    registerEvents() {
        const $document = $(document);

        $document.on(
            "click",
            this.elms.btnNextTutorial,
            this.onNext.bind(this),
        );
        $document.on(
            "click",
            this.elms.btnBackTutorial,
            this.onBack.bind(this),
        );
        $document.on(
            "click",
            this.elms.btnCloseTutorial,
            this.closeTutorial.bind(this),
        );
        $(window).on("resize", this.setTutorialPosition.bind(this));

        this.initialized = true;
    }

    setTutorialPosition() {
        const $tutorial = $(this.elms.tutorial);
        if (!$tutorial.length || $tutorial.attr("data-type") == "modal") return;

        const $tutorialItems = $tutorial.find(".tutorial__body");

        $tutorialItems.each(function () {
            const $target = $($(this).attr("data-selector"));
            const $tutorial = $(this);
            const $spot = $tutorial.find(".tutorial__spot");
            const $arrow = $tutorial.find(".tutorial__spot__arrow");
            const $circle = $tutorial.find(".tutorial__spot__circle");
            const isTargetExist = $target.length > 0;

            if (!isTargetExist) {
                $tutorial.addClass("is-target-document");
                return;
            }

            computePosition($target[0], $tutorial[0], {
                middleware: [
                    autoPlacement({ autoAlignment: true }),
                    offset(8),
                    shift({ padding: 16 }),
                    arrow({ element: $spot[0] }),
                ],
            }).then(({ x, y, middlewareData, placement }) => {
                const originalSide = placement.split("-")[0];
                const invertedSide = inverses[originalSide];

                const left = middlewareData.arrow.x
                    ? `${middlewareData.arrow.x}px`
                    : undefined;

                const top = middlewareData.arrow.y
                    ? `${middlewareData.arrow.y}px`
                    : undefined;

                $spot.css({ left, top, [invertedSide]: "-30px" });
                $tutorial.css({ top: `${y}px`, left: `${x}px` });
                $arrow.css({ [`border-${originalSide}-color`]: "#fff" });
                $circle.css({ [originalSide]: "16px" });
            });
        });
    }

    onNext(e) {
        e.preventDefault();
        const $currentTutorial = $(e.target).parents(".tutorial__body");
        const $nextTutorial = $currentTutorial.next();

        if (!$nextTutorial.length) {
            this.closeTutorial();
            return;
        }

        $currentTutorial.addClass("is-hide");
        $nextTutorial.removeClass("is-hide");
    }

    closeTutorial() {
        $(this.elms.tutorial).removeClass("is-open");
        this._setHasSeen(this.roomId);
    }

    onBack(e) {
        const $currentTutorial = $(e.target).parents(".tutorial__body");
        const $prevTutorial = $currentTutorial.prev();

        if ($prevTutorial.length) {
            $currentTutorial.addClass("is-hide");
            $prevTutorial.removeClass("is-hide");
        }
    }
}
